/**
 * API Configuration for Progetto Sabrina.
 *
 * ALWAYS uses the current browser origin so that API calls go to the
 * SAME domain the user is on.  This avoids any cross-origin (CORS) issue
 * regardless of which URL serves the app:
 *   - preview   → ai-teach-hub-2.preview.emergentagent.com
 *   - deploy    → lesson-gen-test.emergent.host
 *   - custom    → www.maestrasabrina.it
 */
import axios from 'axios';

export const API_URL = window.location.origin;

// Global axios interceptor: adds Bearer token from localStorage to every request.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('sabrina_session');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});
